import { useState, useEffect, useContext, FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { documentosListaResposta } from '../../interfaces/documentosDigitais'
import { atualizarDocumento, listarDocumentoDigital } from '../../services/documentosDigitais'
import { toast } from 'react-toastify'
import { criptografarDado, descriptografarDado } from '../../helpers'
import Permissoes from '../../middleware/Permissoes'
import FiltrosDefault from '../FiltrosDefault'
import avatarDefault from '../../assets/img/avatarDefault.png'
import DivSituacao from '../DivSituacao'
import LoagindBarra from '../LoadingBarra'
import erroImg from '../../assets/img/erroFechar.png'
import visualizarDoc from '../../assets/img/documento.png'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import ModalDocumentosDigitais from '../ModalDocumentosDigitais'
import ModulosContratados from '../../middleware/SistemasContratados'
import './documentos.css'
import { buscarSaldos } from '../../services/modulos'
import { Button, Loader } from '../Styles'

function DocumentosDigitais() {

    const { modalEstado, exibirModal, atualizarInformacoes } = useContext(ModalEstadoContext)

    const navigate = useNavigate()
    const location = useLocation()

    const { pathname, search } = location
    const paramsUrl = new URLSearchParams(search)

    const data = new Date()

    const ano = data.getFullYear()
    const qtnDias = new Date(data.getFullYear(), data.getMonth() + 1, 0).getDate()
    const dataAnterior = new Date(new Date().setDate(new Date().getDate() - 360))

    const [dataInicial, setDataInicial] = useState(`${dataAnterior.getFullYear()}-${(dataAnterior.getMonth() + 1).toString().padStart(2, '0')}-01`);
    const [dataFinal, setDataFinal] = useState(`${ano}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${qtnDias}`);
    const escritorio = paramsUrl.get('escritorio') || 'false'

    const [documentos, setDocumentos] = useState<documentosListaResposta[]>([])
    const [documentoSelecionado, setDocumentoSelecionado] = useState<documentosListaResposta>()
    const [modalDocumentos, setModalDocumentos] = useState(false)
    const [pagina, setPagina] = useState(2)
    const [cliente, setCliente] = useState('')
    const [situacao, setSituacao] = useState('')
    const [tipo] = useState('documento')
    const [processando, setProcessando] = useState(false)
    const [processandoPesquisa, setProcessandoPesquisa] = useState(false)
    const [saldoDisponivel, setSaldoDisponivel] = useState("")
    const [nenhumResultado, setNenhumResultado] = useState(false)
    const [filtroAvancado, setFiltroAvancado] = useState(false)

    const exibirModalDocumentos = () => {

        if (parseInt(saldoDisponivel) <= 0) {

            toast.error('Saldo Infuciente. Por favor realize uma nova recarga de documentos para continuar a usar')

            setTimeout(() => {

                toast.error('Acesse o menu suporte > Solicitar Atendimento > Realize a solicitação de quantos documentos precisar')

            }, 1000)

            setTimeout(() => {

                toast.error('O pedido mínimo é de 50 documentos e o custo de cada um é R$ 2,10')

            }, 2000)

            return
        }

        return exibirModal()
    }

    const scrollInfinito = (e: any) => {

        const { scrollTop, clientHeight, scrollHeight } = e.target

        const posicaoScroll = (scrollTop / (scrollHeight - clientHeight) * 100)

        if (posicaoScroll >= 90) {

            setPagina(prevtState => prevtState + 1)

            const buscarMaisDocumentos = async () => {

                const params = {
                    pagina,
                    nomeCadastro: cliente,
                    situacao,
                    dataInicial,
                    dataFinal,
                    escritorio
                }

                try {

                    const resposta = await listarDocumentoDigital(params)

                    if (resposta.status === 200) {
                        setDocumentos(prevDate => [...prevDate, ...resposta.data])
                        return
                    }

                } catch (error) {
                    toast.error("Erro ao Executar o Scroll Infinito")
                }
            }

            buscarMaisDocumentos()
        }
    }

    const exibirModalDadosDocumentos = (documento: documentosListaResposta, idDocumento: string) => {

        const escritorio = paramsUrl.get('escritorio')

        if (escritorio) {

            navigate(`${pathname}?escritorio=true&idDocumento=${idDocumento}`)
            exibirModal()

            return setDocumentoSelecionado(documento)
        }

        navigate(`${pathname}?idDocumento=${idDocumento}`)
        exibirModal()

        return setDocumentoSelecionado(documento)
    }

    const buscarDocumentos = async (e?: FormEvent) => {

        e?.preventDefault()
        setNenhumResultado(false)
        setFiltroAvancado(false)
        setProcessandoPesquisa(true)

        const params = {
            pagina: 1,
            nomeCadastro: cliente,
            situacao,
            dataInicial,
            dataFinal,
            escritorio
        }

        try {

            const resposta = await listarDocumentoDigital(params)

            if (resposta.data.length === 0) {
                setProcessandoPesquisa(false)
                setDocumentos(resposta.data)
                return setNenhumResultado(true)
            }

            if (resposta.status === 200) {
                setDocumentos(resposta.data)
                return setProcessandoPesquisa(false)
            }

        } catch (error) {

            setProcessandoPesquisa(false)
            toast.error("Erro ao Buscar Documentos")

        }
    }

    const cancelarDocumento = async (idDocumento: string) => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'doc_cancelar']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para cancelar um Documento.")
        setProcessandoPesquisa(true)

        try {

            const payload = {
                situacao: "Cancelado"
            }

            const resposta = await atualizarDocumento(idDocumento, payload)

            if (resposta.status === 200) {
                toast.success("Documento cancelado!")
                return setProcessandoPesquisa(false)
            }

        } catch (error) {
            setProcessandoPesquisa(false)
            toast.error("Erro ao Cancelar Documento")
        }

    }

    useEffect(() => {

        setModalDocumentos(modalEstado)

        if (!modalEstado) setDocumentoSelecionado(undefined)

    }, [modalEstado])

    useEffect(() => {

        const buscarDocumento = async () => {

            setNenhumResultado(false)
            setProcessando(true)

            const params = {
                pagina: 1,
                nomeCadastro: cliente,
                situacao,
                dataInicial,
                dataFinal,
                escritorio
            }

            try {

                const resposta = await listarDocumentoDigital(params)

                if (resposta.data.length === 0) {
                    setDocumentos(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if (resposta.status === 200) {
                    setDocumentos(resposta.data)
                    const documentoAtualizado = resposta.data.find(
                        (documento: documentosListaResposta) => documento.id === documentoSelecionado?.id
                    )
                    if (documentoAtualizado) {
                        setDocumentoSelecionado(documentoAtualizado)
                    }
                    setProcessando(false)
                    return
                }

            } catch (error) {
                toast.error("Erro ao Buscar os Documentos")
            }
        }

        buscarDocumento()

    }, [atualizarInformacoes, escritorio])


    useEffect(() => {
        const buscarSaldoDisponivel = async () => {

            const idOrganizacao = localStorage.getItem("organizacaoGesttor")

            try {

                if (!idOrganizacao) return toast.error("Não foi Possivel Encontrar Parametros Obrigatórios")

                const idOrganizacaoCript = criptografarDado(idOrganizacao)
                const resposta = await buscarSaldos(idOrganizacaoCript)

                setSaldoDisponivel(resposta.data.saldoDoc)

            } catch (error) {
                toast.error("Erro ao Buscar o Saldo Disponivel")
            }
        }

        buscarSaldoDisponivel()

    }, [])

    return (
        <ModulosContratados modulo={["Documentos"]}>
            <Permissoes permissoes={['master', 'administrativo', 'doc_assinatura', 'doc_solicitacoes']}>
                <div id='paginaContainer'>
                    {modalDocumentos && <ModalDocumentosDigitais documento={documentoSelecionado} />}
                    {processando && <LoagindBarra />}
                    {nenhumResultado && <NenhumResultadoEncontrado />}
                    <FiltrosDefault termo={cliente} situacao={situacao} placeholder='Pesquise pelo nome fantasia, responsável ou fornecedor' tipo={tipo} onChangeTermo={(e) => setCliente(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarDocumentos} acaoBtn={exibirModalDocumentos} listaSituacao={[{ nome: 'Todas', valor: '' }, { nome: 'Aguardando Assinatura', valor: 'Aguardando Assinatura' }, { nome: 'Cancelado', valor: 'Cancelado' }, { nome: 'Assinado', valor: 'Assinado' }]} genero='masculino' isLoading={processandoPesquisa} acaoMaisFiltro={() => setFiltroAvancado(true)} maisFiltros={true} />
                    {filtroAvancado &&
                        <div className="fundoModal">
                            <div onClick={() => setFiltroAvancado(false)} />
                            <section className="containerModalCentro">
                                <div id='novoContainerTitulo'>
                                    <p>Filtrar Documentos</p>
                                </div>
                                <form id='formModalNovo' onSubmit={buscarDocumentos}>
                                    <section>
                                        <span>
                                            <label>Nome Fantasia</label>
                                            <input
                                                type='text'
                                                value={cliente}
                                                placeholder="Pesquise pelo Nome Fantasia"
                                                onChange={(e) => setCliente(e.target.value)}
                                            />
                                        </span>
                                    </section>
                                    <section>
                                        <span>
                                            <label>Situação</label>
                                            <select value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                                                <option value=''>Todas as Situações</option>
                                                <option value='Aguardando Assinatura'>Aguardando Assinatura</option>
                                                <option value='Assinado'>Assinado</option>
                                                <option value='Cancelado'>Cancelado</option>
                                            </select>
                                        </span>
                                    </section>

                                    <section>
                                        <span>
                                            <label htmlFor="dataInicial">Data Inicial</label>
                                            <input
                                                id="dataInicial"
                                                value={dataInicial}
                                                type="date"
                                                onChange={(e) => setDataInicial(e.target.value)}
                                            />
                                        </span>
                                        <span>
                                            <label htmlFor="dataFinal">Data Final</label>
                                            <input
                                                id="dataFinal"
                                                value={dataFinal}
                                                type="date"
                                                onChange={(e) => setDataFinal(e.target.value)}
                                            />
                                        </span>
                                    </section>
                                    <span id="botoesContainer">
                                        <Button type='button' cor='cancelar' isLoading={processando} onClick={() => setFiltroAvancado(false)}>Cancelar</Button>
                                        <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                            {!processando && 'Filtrar'}
                                            {processando && <Loader isLoading={processando} />}
                                        </Button>
                                    </span>
                                </form>
                            </section>
                        </div>}
                    <section id='fundoContainerPagina' onScroll={scrollInfinito}>
                        <table id='tabelaListaContainer'>
                            <thead>
                                <tr>
                                    <th id='ladoEsquerdoContent' align='left'>Cliente</th>
                                    <th id='tituloDocumento' align='left'>Documento</th>
                                    <th align='left'>Solicitado por</th>
                                    <th align='center'>Situação</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {documentos.map((documento) => (
                                    <tr key={Math.random()}>
                                        <td id='primeiraColuna' onClick={() => exibirModalDadosDocumentos(documento, documento.id)}>{documento.cadastro.nomeFantasia}</td>
                                        <td onClick={() => exibirModalDadosDocumentos(documento, documento.id)}>{documento.tituloDocumento}</td>
                                        <td align='center' className='usuarioResponsavelContent' onClick={() => exibirModalDadosDocumentos(documento, documento.id)}>
                                            <img className='usuarioResponsavel' src={documento.usuario.avatar ? documento.usuario.avatar : avatarDefault} alt='' />
                                            {documento.usuario.nome}
                                        </td>
                                        <td align='center' onClick={() => exibirModalDadosDocumentos(documento, documento.id)}>
                                            <DivSituacao texto={`${documento.situacao.charAt(0).toUpperCase().concat()}${documento.situacao.substring(1)}`} cor={documento.situacao.toLowerCase().replace(/\s+/g, '')} />
                                        </td>
                                        <td id='ladoDireitoContent' align='center'>
                                            <a href={documento.docAssinado ? documento.docAssinado : documento.docOriginal} target="_blank" rel="noreferrer"><img className='acoesIconeDocumento' title={documento.docAssinado ? 'Visualizar Documento Assinado' : 'Visualizar Documento Original'} src={visualizarDoc} alt='' /></a>
                                            <Permissoes permissoes={['master', 'doc_cancelar']}>
                                                <>
                                                    {documento.situacao === "Aguardando Assinatura" && <img className='acoesIconeDocumento' title='Cancelar Documento' src={erroImg} alt='' onClick={() => { cancelarDocumento(documento.id) }} />}
                                                </>
                                            </Permissoes>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section>
                </div>
            </Permissoes>
        </ModulosContratados>
    )
}

export default DocumentosDigitais
